
import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {
  usePostABTestingEventLog,
  usePostPageIdUserNameFlight,
  CUSTOMER_JOURNEY_PRODUCT,
  CUSTOMER_JOURNEY_SUB_PRODUCT,
  CustomerJourneyProvider,
} from '@bingads-webui-campaign-react/shared-app-capi';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

export function CustomerJourneyProviderWithContext({ children }) {
  const serverContext = useContext(ServerContext);
  const instrumentation = useContext(InstrumentationContext);

  const customerJourneyTrace = useMemo(() => {
    if (instrumentation && instrumentation.customerJourneyScenario) {
      const scenario = instrumentation.customerJourneyScenario.create();
      return scenario.customerJourney.create().trace;
    }
    return _.noop;
  }, [instrumentation]);

  const postABTestingEventLog = usePostABTestingEventLog(serverContext, customerJourneyTrace);

  const flights = [{
    ExperimentName: 'TestExperimentName1',
    Flight: 'TestFlight1',
  }];

  const postABTestingFlightLog = usePostPageIdUserNameFlight(serverContext, customerJourneyTrace);

  return (
    <CustomerJourneyProvider
      shouldPost={!!(customerJourneyTrace)}
      logWarning={customerJourneyTrace}
      postEventLog={postABTestingEventLog}
      serverContext={serverContext}
      flights={flights}
      postFlightLog={postABTestingFlightLog}
      product={CUSTOMER_JOURNEY_PRODUCT.PMaxLite}
      subProduct={CUSTOMER_JOURNEY_SUB_PRODUCT.None}
    >
      {children}
    </CustomerJourneyProvider>
  );
}

CustomerJourneyProviderWithContext.propTypes = {
  children: PropTypes.node.isRequired,
};
